
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M9 13C11.2091 13 13 11.2091 13 9C13 6.79086 11.2091 5 9 5C6.79086 5 5 6.79086 5 9C5 11.2091 6.79086 13 9 13Z' fill='#323232'/><path d='M9 15C6.33 15 1 16.34 1 19V20C1 20.55 1.45 21 2 21H16C16.55 21 17 20.55 17 20V19C17 16.34 11.67 15 9 15ZM15.47 7.76998C15.79 8.55998 15.79 9.43998 15.47 10.23C15.28 10.7 15.36 11.23 15.72 11.59L15.75 11.62C16.33 12.2 17.32 12.08 17.7 11.35C18.46 9.89998 18.46 8.19998 17.68 6.68998C17.3 5.94998 16.3 5.80998 15.71 6.39998L15.7 6.40998C15.36 6.75998 15.28 7.29998 15.47 7.76998ZM19.18 2.88998C18.78 3.28998 18.72 3.90998 19.05 4.36998C21.02 7.10998 21.01 10.78 19.02 13.62C18.7 14.07 18.77 14.69 19.16 15.08L19.19 15.11C19.68 15.6 20.51 15.56 20.93 15.01C23.68 11.47 23.69 6.63998 20.93 2.98998C20.51 2.43998 19.67 2.39998 19.18 2.88998Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-record-voice-over`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconRecordVoiceOver

    ```js
    <b-new-b-icon-record-voice-over />
    ```
</docs>


